import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireSession } from '../../../auth/require-session.js';
import { SessionError, SessionPending } from '../../../auth/SessionStates.js';

/** `/sheets/pc` (2.H deliverable 5): the layout of the PC sheet, guarded as `/` is. */
export const Route = createFileRoute('/sheets/pc')({
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  staticData: { crumb: 'Character sheet' },
  component: Outlet,
});
